module.exports = __webpack_public_path__ + "static/media/tank-new.f887f8af.png";